module.exports = __webpack_public_path__ + "img/Infografis_ID_12.cb06c598.jpg";